export const pattern = {
  email: "^[a-zA-Z0-9._%+'&,-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
  // letters / digits; two parts may be joined by a space, "-" or " - "
  zipCode: "^[A-Za-z0-9]+(?:(?: ?- ?| )[A-Za-z0-9]+)?$",
  // /^\w+[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
};

export const GetOffset = (el) => {
  let x = 0;
  let y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: y, left: x };
};